/*
 This element receives product array and shows them in the select box
 */

import React, {useCallback, useState, useEffect} from 'react'
import store from '../../store/store'
import {  useDispatch, useSelector } from "react-redux";
import {
    fetchProductById,
    setNextSelection,
    setProductId, clearData
} from "../../store/product/productDataSlice";
import {getPatternsAvailable, setPatternId} from "../../store/details/patternDetailsSlice";
import {expandCategoriesChanged, expandProductsChanged, setIsPattern} from "../../store/configuratorStateSlice";
import {categoryIdSet, setProductIdDetails} from "../../store/details/projectDetailsSlice";
import placeholder from '../../../../assets/images/placeholder-100x100.png';
import ProductSelectionView from "./productSelection/ProductSelectionView";
const ProductSelectorStep = (props) => {
    const dispatch = useDispatch();
    const currentValue = useSelector(state => state.projectDetailsReducer.productID);
    const categoryId = useSelector(state =>state.projectDetailsReducer.categoryID);
    const showProducts = useSelector(state => state.configuratorStateReducer.uiState.expandProducts)
    const showCategories = useSelector(state => state.configuratorStateReducer.uiState.expandCategories)
    const [currentCategory, setCurrentCategory] = useState(null);
    const [distanceLeft, setDistanceLeft] = useState(0);
    // this is specifically for cases where a product visible by admins only is selected
    // but the current user is not logged in as one
    const [productNotFound, setProductNotFound] = useState(false)

    const productKey = (product) => {
        // patterns have different product keys since id is shared between product and pattern
        if(product && product.pattern_attribute_id != null){
            return 'pattern-' + product.id;
        } else {
            return product ?  product.id : null;
        }
    };

    useEffect(() => {
        setCurrentCategory(categoryId)
    }, [categoryId])

    // get distance of GO button from part numberlookup so we can apply styles
    // to the change category/product buttons.
    useEffect(() => {
        const goButtonPos = $('#catalog_number_button').position();
        const goButtonWidth = $('#catalog_number_button').outerWidth();
        setDistanceLeft(goButtonPos.left + goButtonWidth);
    }, [])

    const handleChange = useCallback( () => {
        const val = event.target.value;
        dispatch(clearData())
        store.dispatch({type: 'SET_ERRORS', value: false});

        if(event.target.value != undefined && event.target.value != "") {
            // if val contains pattern then adjust the store to match
            if(val.includes('pattern')){
                dispatch(setIsPattern(true));
                dispatch(setProductIdDetails(val))
                dispatch(setProductId( val.replace('pattern-', '')));
                dispatch(setPatternId( val.replace('pattern-', '')));
                dispatch(getPatternsAvailable());
            } else {
                dispatch(setIsPattern(false));
                dispatch(fetchProductById(val))
            }
            dispatch(expandProductsChanged(false));
        }
    }, [dispatch, fetchProductById]);

    const handleCategoryChange = (e, value) => {
        // e.preventDefault();
        dispatch(clearData())
        setCurrentCategory(value);
        dispatch(expandProductsChanged(true))
        dispatch(expandCategoriesChanged(false))
        dispatch(categoryIdSet(value));
    }

    const categories = props.categories || [];
    const products = props.products.filter(prod => prod.product_category_id == currentCategory) || [];

    const getThumbFromImage = (image) => {
        if(process.env.NODE_ENV === 'development'){
            return placeholder
        } else if(image) {
            return window.location.origin + image.small_thumb.url;
        } else {
            return null
        }

    }
    const productSelection = () => {
        if(currentCategory) {
            const opt = products.find(prod => productKey(prod) == currentValue);
            return (
                <ProductSelectionView
                    title={'Product'}
                    distanceLeft={distanceLeft}
                    image={getThumbFromImage(opt ? opt.image : null)}
                    productKey={productKey(opt)}
                    handleClick={() => dispatch(expandProductsChanged(true))}
                    buttonText={'Change Product'}
                    options={getOptionsForRadio(products, 'products', currentValue, handleChange)}
                    hideList={!showProducts}
                    optionText={opt ? opt.name : null}
                />
            )
        } else {
            return null;
        }
    }

    const getOptionsForRadio = (options, name, current, onChange) => {
        return options.map((opt, index) =>
            <label className={"enabled label_radio category-radio " + (productKey(opt) == current ? 'selected':'')} key={productKey(opt)}>
                <img src={getThumbFromImage(opt.image)} className={"product-category-image " + (productKey(opt) == current ? 'selected':'')} />
                <input style={{display: "none"}} type="radio" key={productKey(opt)} value={productKey(opt)} name={name} defaultChecked={productKey(opt) == current} onChange={(e) => onChange(e,opt.id)}></input>
                <b className="checkbox"></b>
                {name == 'product_categories' ? opt.description : opt.name}
            </label>)
    }

    const productCategories = () => {
        const opt = categories.find(cat => cat.id === currentCategory);

        return (
            <ProductSelectionView
                title={'Product Category'}
                distanceLeft={distanceLeft}
                image={getThumbFromImage(opt ? opt.image : null)}
                productKey={productKey(opt)}
                handleClick={() => dispatch(expandCategoriesChanged(true))}
                buttonText={'Change Category'}
                options={getOptionsForRadio(categories, 'product_categories', currentCategory, handleCategoryChange)}
                hideList={!showCategories}
                optionText={opt ? opt.description : null}
            />

        )
    }

    return (
        <div className="product-selector-wrapper">
            { productCategories() }
            { productSelection() }
        </div>
    )
};


export default ProductSelectorStep;
